const originalProductMedia = new WeakMap();

function closeLegacyMenu(header, restoreFocus = false) {
  header.classList.remove('menu-open');
  const button = header.querySelector('.menu-toggle');
  if (button) {
    button.setAttribute('aria-expanded', 'false');
    if (restoreFocus) button.focus();
  }
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('.menu-toggle');
  if (button) {
    const header = button.closest('header');
    if (header) {
      const open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open));
      header.classList.toggle('menu-open', open);
    }
  }

  const navLink = event.target.closest('header nav a');
  if (navLink) {
    const header = navLink.closest('header');
    if (header) closeLegacyMenu(header);
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('header.menu-open').forEach((header) => closeLegacyMenu(header, true));
});

function updateProductMedia(image, option) {
  if (!image) return;

  if (!originalProductMedia.has(image)) {
    originalProductMedia.set(image, {
      src: image.getAttribute('src'),
      srcset: image.getAttribute('srcset'),
      alt: image.alt
    });
  }

  const original = originalProductMedia.get(image);
  if (option.dataset.image) {
    image.setAttribute('src', option.dataset.image);
    if (option.dataset.imageSrcset) image.setAttribute('srcset', option.dataset.imageSrcset);
    else image.removeAttribute('srcset');
    image.alt = option.dataset.imageAlt || original.alt;
    return;
  }

  if (original.src !== null) image.setAttribute('src', original.src);
  if (original.srcset !== null) image.setAttribute('srcset', original.srcset);
  else image.removeAttribute('srcset');
  image.alt = original.alt;
}

function syncProductVariant(select, updateUrl) {
  const section = select.closest('[data-product-section]');
  const option = select.selectedOptions[0];
  if (!section || !option) return;

  const button = section.querySelector('[data-add-button]');
  const price = section.querySelector('[data-product-price]');
  const compare = section.querySelector('[data-compare-price]');
  if (!button || !price || !compare) return;

  if (!select.value) {
    button.disabled = true;
    button.textContent = button.dataset.choose;
    section.querySelectorAll('[data-ath-dynamic-checkout]').forEach((element) => { element.hidden = true; });
    return;
  }

  button.disabled = option.dataset.available !== 'true' || select.form?.dataset.athSubmitting === 'true';
  button.textContent = option.dataset.available !== 'true' ? button.dataset.soldOut : button.dataset.add;
  price.textContent = option.dataset.price;
  compare.textContent = option.dataset.compare || '';
  compare.hidden = !option.dataset.compare;
  section.querySelectorAll('[data-ath-dynamic-checkout]').forEach((element) => {
    element.hidden = button.disabled;
  });
  updateProductMedia(section.querySelector('[data-primary-image]'), option);

  if (updateUrl) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', select.value);
    window.history.replaceState(null, '', url);
  }
}

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-variant-select]')) syncProductVariant(event.target, true);
});

document.querySelectorAll('[data-variant-select]').forEach((select) => syncProductVariant(select, false));
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-variant-select]').forEach((select) => syncProductVariant(select, false));
});

function initializeEditorialVariantDefaults(scope = document) {
  scope.querySelectorAll('[data-ath-pdp]').forEach((root) => {
    const addButton = root.querySelector('[data-add-button]');
    const addText = root.querySelector('[data-add-text]');
    if (addButton && addText && !addButton.dataset.athAddLabel) {
      addButton.dataset.athAddLabel = addText.textContent.trim();
    }

    root.querySelectorAll('fieldset[data-option-position]').forEach((fieldset) => {
      const inputs = [...fieldset.querySelectorAll('[data-option-input]')];
      if (inputs.length !== 1 || inputs[0].checked) return;
      inputs[0].checked = true;
      inputs[0].dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
}

function restoreSingleVariantEditorialState(event) {
  const root = event.target.closest?.('[data-ath-pdp]');
  if (!root || root.querySelector('[data-option-input]')) return;

  const variantInput = root.querySelector('[data-variant-id]');
  const variantData = root.querySelector('[data-product-variants]');
  const addButton = root.querySelector('[data-add-button]');
  const addText = root.querySelector('[data-add-text]');
  if (!variantInput || !variantData || !addButton || !addText) return;

  try {
    const variant = JSON.parse(variantData.textContent || '[]')[0];
    if (!variant) return;
    variantInput.value = variant.id;
    variantInput.disabled = false;
    addButton.disabled = !variant.available;
    addText.textContent = variant.available
      ? (addButton.dataset.athAddLabel || addText.textContent)
      : root.dataset.unavailable;
  } catch (_) {
    // Keep Shopify's server-rendered form state if variant JSON is unavailable.
  }
}

document.addEventListener('ath:cart:complete', (event) => {
  const select = event.target.querySelector('[data-variant-select]');
  if (select) syncProductVariant(select, false);
  restoreSingleVariantEditorialState(event);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeEditorialVariantDefaults(document), { once: true });
} else {
  initializeEditorialVariantDefaults(document);
}
document.addEventListener('shopify:section:load', (event) => initializeEditorialVariantDefaults(event.target));
